import gql from 'graphql-tag';

import accountCardDetails from '../../../../../../services/cards/graphql/fragments/accountCardDetails';

const getUserAccountCardsQuery = gql`
  query getUserAccountCardsQuery(
    $status: AccountCardStatusEnum
    $limit: Int = 30
    $offset: Int = 0
    $cardType: CardTypeEnum
    $customPrintTypes: [CustomPrintTypeEnum]
    $customPrintSubtype: CustomPrintSubtypeEnum
    $albumFolderId: RecordID
    $accountCardAlbumFolderId: RecordID
  ) {
    me {
      id
      account_cards(
        slice: { limit: $limit, offset: $offset }
        status: $status
        card_type: $cardType
        custom_print_types: $customPrintTypes
        custom_print_subtype: $customPrintSubtype
        album_folder_id: $albumFolderId
        account_card_album_folder_id: $accountCardAlbumFolderId
      ) {
        total
        records {
          ...accountCardDetails
        }
      }
    }
  }
  ${accountCardDetails}
`;

export default getUserAccountCardsQuery;
